import { list } from './../api/appUpgrade';
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { h5Routes } from './h5-router'
import { OpenRoutes } from './open-router'

/**
 * 配置路由
 */
Vue.use(VueRouter)


/**
 * 路由地址
 */
import Layout from '@/views/layout/index.vue'
import Login from '@/views/login/index.vue'
import NotFound from '@/views/404/index.vue'
import Empty from '@/views/empty/index.vue'


/**
 * 路由输出
 * 路由path为固定的，需要与当前登录的用户所获得的菜单权限进行匹配，以path为匹配的标准，如果与路由的path不符合则跳转到empty界面
 */
export const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '/',
    redirect: "/Layout"
  },
  {
    path: '/empty',
    name: 'empty',
    component: Empty
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/h5',
    component: () => import('@/H5App.vue'),
    children: h5Routes
  },
  {
    path: "/open",
    component: () => import('@/OpenApp.vue'),
    children: OpenRoutes
  },
  {
    path: '/layout',
    component: Layout,
    children: [
      {
        path: '/',
        redirect: '/home'
      },
      {
        path: '/home',
        name: '首页',
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: '/storeList',
        name: '门店信息',
        component: () => import('@/views/store-list/index.vue'),
      },
      {
        path: '/storeFill',
        name: '新增\编辑门店信息',
        component: () => import('@/views/store-list/fill.vue'),
      },
      {
        path: '/userMember',
        name: '用户管理',
        component: () => import('@/views/user-member/index.vue'),
      },
      {
        path: '/productList',
        name: '产品列表',
        component: () => import('@/views/product-list/index.vue'),
      },
      {
        path: '/productUse',
        name: '产品消耗',
        component: () => import('@/views/product-use/index.vue'),
      },
      {
        path: '/device',
        name: '设备管理',
        component: () => import('@/views/device/index.vue'),
      },
      {
        path: '/deviceType',
        name: '设备类型',
        component: () => import('@/views/device-type/index.vue'),
      },
      {
        path: '/qiaoDevice',
        name: '脉诊设备',
        component: () => import('@/views/qiaoDevice/index.vue'),
      },
      {
        path: '/appCompose',
        name: 'app排版',
        component: () => import('@/views/app-compose/index.vue'),
      },
      {
        path: '/merchantAppCompose',
        name: '品牌方app排版',
        component: () => import('@/views/app-compose/index.vue'),
      },
      {
        path: '/appUpgrade',
        name: 'app升级',
        component: () => import('@/views/app-upgrade/index.vue'),
      },
      
      {
        path: '/admin',
        name: '管理员',
        component: () => import('@/views/admin/index.vue'),
      },
      {
        path: '/dataDictionary',
        name: '数据字典',
        component: () => import('@/views/data-dictionary/index.vue'),
      },
      {
        path: '/user',
        name: '用户列表',
        component: () => import('@/views/user/index.vue'),
      },
      {
        path: '/menu',
        name: '菜单列表',
        component: () => import('@/views/menu/index.vue'),
      },
      {
        path: '/resource',
        name: '资源列表',
        component: () => import('@/views/resource/index.vue'),
      },
      {
        path: '/resourceCategory',
        name: '资源分类',
        component: () => import('@/views/resource-category/index.vue'),
      },
      {
        path: '/tongueList',
        name: '诊断次数',
        component: () => import('@/views/tongue-list/index.vue'),
      },   {
        path: '/tongueSug',
        name: '舌诊管理',
        component: () => import('@/views/tongue-sug/index.vue'),
      },
      {
        path: '/channelSignage',
        name: '服务商看板数据',
        component: () => import('@/views/service-provider/index.vue'),
      },
      {
        path: '/lungList',
        name: '肺功能管理',
        component: () => import('@/views/lung-list/index.vue'),
      },
      {
        path: '/productCategory',
        name: '产品分类管理',
        component: () => import('@/views/product-category/index.vue'),
      },
      {
        path: '/prescriptionDb',
        name: '处方库',
        component: () => import('@/views/prescription-db/index.vue'),
      },
      {
        path: '/miniManage',
        name: '小程序排版',
        component: () => import('@/views/appManage/mini.vue'),
      },
      {
        path: '/buildStoreManage',
        name: '建店配置',
        component: () => import('@/views/buildStores/index.vue'),
      },
      {
        path: '/buildStoreList',
        name: '建店列表',
        component: () => import('@/views/buildStores/list.vue'),
      },
      {
        path: '/moxibustionTemplate',
        name: '云端模版',
        component: () => import('@/views/moxibustion/template.vue'),
      },
      {
        path: '/moxibustionOrder',
        name: '订单列表',
        component: () => import('@/views/moxibustion/order.vue'),
      },
      {
        path: '/merchantList',
        name: '品牌方',
        component: () => import('@/views/prescription-db/brand.vue'),
      },
      {
        path: '/merchantDb',
        name: '品牌方处方库',
        component: () => import('@/views/prescription-db/merchant.vue'),
      },
      {
        path: '/physique',
        name: '体质辨识症状',
        component: () => import('@/views/physique/index.vue'),
      },
      {
        path: '/merchantProductCategory',
        name: '品牌方产品分类',
        component: () => import('@/views/product-category/merchant.vue'),
      },
      {
        path: '/storeActivity',
        name: '门店活动',
        component: () => import('@/views/storeActivity/index.vue'),
      },
      {
        path: '/booking',
        name: '门店预约',
        component: () => import('@/views/booking/index.vue'),
      },
      {
        path: '/merchant-booking',
        name: '品牌方门店预约',
        component: () => import('@/views/booking/merchant.vue'),
      },
      {
        path: '/bookingData',
        name: '预约看板',
        component: () => import('@/views/booking/data.vue'),
      },
      {
        path: '/userDetectionRecord',
        name: '用户检测次数',
        component: () => import('@/views/user-detection-record/index.vue'),
      },
      {
        path: '/healthEvaluationList',
        name: '健康测评',
        component: () => import('@/views/healthEvaluation/index.vue'),
      },
      {
        path: '/healthEvaluationFill',
        name: '试卷配置',
        component: () => import('@/views/healthEvaluation/fill.vue'),
      },
      {
        path: '/userDetectionList',
        name: '客户检测记录',
        component: () => import('@/views/user-detection-record/detection.vue'),
      },
      {
        path: '/userRecuperateList',
        name: '客户调理记录',
        component: () => import('@/views/user-detection-record/recuperate.vue'),
      },
      {
        path: '/storeData',
        name: '门店数据',
        component: () => import('@/views/data/store.vue'),
      },
      {
        path: '/tongueApiStatistics',
        name: '舌诊API统计',
        component: () => import('@/views/report/tongueApiStatistics.vue'),
      },
      {
        path: '/restSetting',
        name: '门店休息',
        component: () => import('@/views/store-list/restSetting.vue'),
      },
      {
        path: '/appDescriptionSetting',
        name: 'APP介绍说明',
        component: () => import('@/views/appManage/description.vue'),
      },
      {
        path: '/appBrandDescriptionSetting',
        name: '品牌方APP介绍说明',
        component: () => import('@/views/appManage/brandDescription.vue'),
      },
      {
        path: '/saasServiceSetting',
        name: 'SAAS服务配置',
        component: () => import('@/views/health/saasService/index.vue'),
      },
      {
        path: '/tongueSetting',
        name: '舌诊管理',
        component: () => import('@/views/tongue/index.vue'),
      },
      {
        path: '/period',
        name: '门店分期',
        component: () => import('@/views/period/index.vue'),
      },
      {
        path: '/watchIndex',
        name: '健康数据',
        component: () => import('@/views/watch/index.vue'),
      },
      {
        path: '/healthRecord',
        name: '健康档案',
        component: () => import('@/views/healthRecord/index.vue'),
      },
      {
        path: '/healthRecordDetail',
        name: '分组详情',
        component: () => import('@/views/healthRecord/detail.vue'),
      },
      {
        path: '/symptoms',
        name: '百症调养',
        component: () => import('@/views/symptoms/index.vue'),
      },
      {
        path: '/brand-symptoms',
        name: '品牌方百症调养',
        component: () => import('@/views/symptoms/brandIndex.vue'),
      },


      {
        path: '/selectRecommendation',
        name: '精选推荐',
        component: () => import('@/views/selectRecommendation/index.vue'),
      },
      {
        path: '/prescription-product-category',
        name: '产品分类配置',
        component: () => import('@/views/prescriptionProduct/category.vue'),
      },
      {
        path: '/prescription-product-list',
        name: '产品分类配置',
        component: () => import('@/views/prescriptionProduct/product.vue'),
      },
      {
        path: '/prescription-product-merchant-category',
        name: '品牌方产品分类配置',
        component: () => import('@/views/prescriptionProduct/merchantCategory.vue'),
      },
      {
        path: '/prescription-product-merchant-list',
        name: '品牌方产品列表',
        component: () => import('@/views/prescriptionProduct/merchantProduct.vue'),
      },
      {
        path: '/instructionSending',
        name: '指令发送',
        component: () => import('@/views/instructionSending/index.vue'),
      },
      {
        path: '/instructionParsing',
        name: '指令解析',
        component: () => import('@/views/instructionParsing/index.vue'),
      },
      {
        path: '/logQuery',
        name: '日志查询',
        component: () => import('@/views/logQuery/index.vue'),
      },
      {
        path: '/nurse-pres',
        name: '调养处方管理',
        component: () => import('@/views/nurse/pres.vue'),
      },
      {
        path: '/nurse-pres-add',
        name: '新增\编辑调养方法',
        component: () => import('@/views/nurse/presAdd.vue'),
      },
      {
        path: '/nurse-pres-add-home',
        name: '新增\编辑居家调养',
        component: () => import('@/views/nurse/presAddHome.vue'),
      },
      {
        path: '/nurse-pres-add-sport',
        name: '新增\编辑运动膳食',
        component: () => import('@/views/nurse/presAddSport.vue'),
      },
      {
        path: '/merchantAction',
        name: '品牌方操作',
        component: () => import('@/views/prescription-db/action.vue'),
      },
      {
        path: '/merchantEdit',
        name: '品牌方新增/编辑',
        component: () => import('@/views/prescription-db/edit.vue'),
      },
      {
        path: '/merchantBanner',
        name: '小程序Banner',
        component: () => import('@/views/banner/index.vue'),
      },
      {
        path: '/merchantMiniSetting',
        name: '小程序配置',
        component: () => import('@/views/prescription-db/miniSetting.vue'),
      },
      {
        path: '/appUpdate',
        name: 'APP系统更新',
        component: () => import('@/views/appUpdate/index.vue'),
      },
      {
        path: '/appUpdateEdit',
        name: 'APP系统更新新增/编辑',
        component: () => import('@/views/appUpdate/edit.vue'),
      },
      {
        path: '/nurse-tenet',
        name: '调养原则管理',
        component: () => import('@/views/nurse/tenet.vue'),
      },
      {
        path: '/solarTerms',
        name: '节气管理',
        component: () => import('@/views/solarTerms/index.vue'),
      },
      {
        path: '/symptomManage',
        name: '症状库管理',
        component: () => import('@/views/symptomManage/index.vue'),
      },
      {
        path: '/product-import',
        name: '产品库批量导入',
        component: () => import('@/views/product-import/index.vue'),
      },
      {
        path: '/dialectic',
        name: '智能辩证管理',
        component: () => import('@/views/dialectic/index.vue'),
      },
      {
        path: '/shareGroupList',
        name: '共享小组管理',
        component: () => import('@/views/shareDevice/group.vue'),
      },
      {
        path: '/customSelf',
        name: '客户自助管理',
        component: () => import('@/views/shareDevice/customSelf.vue'),
      },
      {
        path: '/clientActivity',
        name: '活动弹窗配置',
        component: () => import('@/views/clientActivity/index.vue'),
      },
      {
        path: '/publicNumberMessage',
        name: '消息提醒',
        component: () => import('@/views/publicNumberMessage/index.vue'),
      },
      {
        path: '/fourDiagnosticList',
        name: '四诊检测记录',
        component: () => import('@/views/fourDiagnosticList/index.vue'),
      },
      {
        path: '/consultation',
        name: '问诊管理',
        component: () => import('@/views/consultation/index.vue'),
      },
      {
        path: '/four-combine',
        name: '四诊合参管理 ',
        component: () => import('@/views/fourCombine/index.vue'),
      },
      {
        path: '/two-hour',
        name: '十二时辰管理 ',
        component: () => import('@/views/two-hour/index.vue'),
      },
      {
        path: '/mixDetection',
        name: '综合检测记录 ',
        component: () => import('@/views/mixDetection/index.vue'),
      },
      {
        path: '/wsProduct',
        name: '望舌知康产品配置',
        component: () => import('@/views/wsProduct/index.vue'),
      },
      {
        path: '/wsProductManager',
        name: '产品管理',
        component: () => import('@/views/wsProduct/manager.vue'),
      },
      {
        path: '/wsProductSetting',
        name: '产品推荐配置',
        component: () => import('@/views/wsProduct/setting.vue'),
      },
      {
        path: '/productCode',
        name: '食养二维码',
        component: () => import('@/views/productCode/index.vue'),
      },
      {
        path: '/productCodeUse',
        name: '验证码消耗记录',
        component: () => import('@/views/productCodeUse/index.vue'),
      },
      {
        path: '/tongueReportConfig',
        name: '舌诊报告配置',
        component: () => import('@/views/prescription-db/tongueReportConfig.vue'),
      },
      {
        path: '/sleepMonitor',
        name: '睡眠监测数据',
        component: () => import('@/views/sleep/index.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// README: 百度埋点，这个最好放在 router 文件里面，防止beforeEach 后续被外部文件覆盖
// @ts-ignore
const _hmt = window._hmt || [];
router.beforeEach(
  (to,from,next)=>{
      if(to.path){
          if(_hmt){
             _hmt.push(['_trackPageview','/#'+to.fullPath]);
          }
      }
      next();
  }
);

export default router
